import { LEARNER_ACCOUNT_STATUS, LEARNER_ACCOUNT_STATUS_LABEL, TLearnerAccountStatus, USER_ACTIVE_STATUS } from "@/types/enum";

/**
 * Get learner account status based on user data and exam status
 */
export const getLearnerAccountStatus = (
  userId?: number | null,
  userActiveStatus?: string | null,
  isArchive?: boolean | null,
  isUserArchive?: boolean | null,
): TLearnerAccountStatus => {
  if (isArchive) {
    return LEARNER_ACCOUNT_STATUS.ARCHIVED;
  }

  if (!userId || (!isUserArchive && userActiveStatus === USER_ACTIVE_STATUS.INACTIVE)) {
    return LEARNER_ACCOUNT_STATUS.NOT_ISSUED;
  }

  if (userActiveStatus === USER_ACTIVE_STATUS.INACTIVE) {
    return LEARNER_ACCOUNT_STATUS.SUSPENDED;
  }

  return LEARNER_ACCOUNT_STATUS.ACTIVE;
};

/**
 * Get learner account status label
 */
export const getLearnerAccountStatusLabel = (
  userId?: number | null,
  userActiveStatus?: string | null,
  isArchive?: boolean | null,
  isUserArchive?: boolean | null,
): string => {
  const status = getLearnerAccountStatus(userId, userActiveStatus, isArchive, isUserArchive);
  return LEARNER_ACCOUNT_STATUS_LABEL[status];
};
